import FormSetup from "./FormSetup";
import { RegistrationProvider } from "../../../../context/RegistrationContext";
function RegistrationForm() {
	
	return (
		<>
			<RegistrationProvider>
				<FormSetup />
			</RegistrationProvider>
		</>
	);
}

export default RegistrationForm;
